import { isPlatformAdminEmail } from '../constants/platformAdmin';
import { supabase } from '../supabaseClient';

export interface PlatformManagerRow {
  user_id: string;
  email: string;
  display_name: string;
  granted_at: string | null;
}

export { isPlatformAdminEmail };

export async function fetchAmIPlatformManager(): Promise<boolean> {
  const { data, error } = await supabase.rpc('is_platform_manager');
  if (error) {
    // 마이그레이션 미적용 등
    if (
      error.code === 'PGRST202' ||
      error.code === '42883' ||
      /could not find|does not exist|404/i.test(error.message)
    ) {
      return false;
    }
    console.error(error);
    return false;
  }
  return data === true;
}

export async function listPlatformManagers(): Promise<PlatformManagerRow[]> {
  const { data, error } = await supabase.rpc('admin_list_platform_managers');
  if (error) {
    if (
      error.code === 'PGRST202' ||
      error.code === '42883' ||
      /could not find|does not exist|404|플랫폼 관리/i.test(error.message)
    ) {
      throw new Error(
        '매니저 권한 테이블/함수가 없습니다. supabase migration 20260803180000_platform_managers.sql 을 적용해 주세요.',
      );
    }
    throw error;
  }
  return (data ?? []).map((row: Record<string, unknown>) => ({
    user_id: String(row.user_id ?? ''),
    email: String(row.email ?? ''),
    display_name: String(row.display_name ?? ''),
    granted_at: row.granted_at != null ? String(row.granted_at) : null,
  }));
}

export async function grantPlatformManager(userId: string): Promise<void> {
  const { error } = await supabase.rpc('admin_grant_platform_manager', {
    p_user_id: userId,
  });
  if (error) throw error;
}

export async function revokePlatformManager(userId: string): Promise<void> {
  const { error } = await supabase.rpc('admin_revoke_platform_manager', {
    p_user_id: userId,
  });
  if (error) throw error;
}

/** 매니저에게만 노출하는 관리자 하위 메뉴 경로 */
export const PLATFORM_MANAGER_ADMIN_PATHS = [
  '/admin/learning-content',
  '/admin/evaluation-plan',
  '/admin/cross-curricular',
  '/admin/learning-plan',
] as const;

export function isPlatformManagerAdminPath(path: string): boolean {
  return PLATFORM_MANAGER_ADMIN_PATHS.some((p) => path === p || path.startsWith(`${p}/`));
}

/** 권한 부여 대상에서 제외 (플랫폼 관리자) */
export function isExcludedFromManagerGrant(email: string): boolean {
  return isPlatformAdminEmail(email);
}
